import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DynamicNode2 } from '@/components/Nodes/DynamicNode/DynamicNode2';
import { I18N_KEYS } from '@/language/keys';
import { color } from '@/colors';
import type { DeprecatedData } from '@/types/node';

function DeprecatedNodeLabel() {
  const { t } = useTranslation();
  return (
    <Typography
      component="span"
      variant="body-sm-rg"
      sx={{
        color: color.Black92,
        backgroundColor: color.White80_T,
        fontFamily: 'DM Mono',
        fontSize: '14px',
        px: 0.5,
        py: 0.25,
        borderRadius: 0.5,
        flexShrink: 0,
      }}
    >
      {t(I18N_KEYS.RECIPE_MAIN.NODES.DEPRECATED.GENERAL)}
    </Typography>
  );
}

function DeprecatedNode({ id, data }: { id: string; data: DeprecatedData }) {
  const { t } = useTranslation();

  const deprecationMessages = {
    compv2: t(I18N_KEYS.RECIPE_MAIN.NODES.DEPRECATED.COMPV2),
    edit: t(I18N_KEYS.RECIPE_MAIN.NODES.DEPRECATED.EDIT),
  };
  return (
    <DynamicNode2 id={id} data={data} titleRight={<DeprecatedNodeLabel />}>
      {deprecationMessages[data.type] && (
        <Typography variant="body-std-rg" sx={{ color: color.White64_T }}>
          {deprecationMessages[data.type]}
        </Typography>
      )}
    </DynamicNode2>
  );
}

export default DeprecatedNode;
